import {UnstyledLinkLinaria} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {OnHoverAppearingTextline} from './ImageTextline';

export const ImageWithHeadAndOverline: React.FC<
  React.PropsWithChildren & {
    dataTestId: string;
    url?: string;
    onClick?: () => void;
  }
> = ({children, dataTestId, onClick, url}) => {
  if (url) {
    return (
      <ImageWithHeadAndOverlineWrapper
        data-testid={dataTestId}
        // @ts-ignore linaria has an issue to referre this styles correctly, therefore we disable to sometimes unknown `to` parameter check
        to={url}
        onClick={onClick}
        as={UnstyledLinkLinaria}
      >
        {children}
      </ImageWithHeadAndOverlineWrapper>
    );
  }
  return (
    <ImageWithHeadAndOverlineWrapper data-testid={dataTestId} onClick={onClick}>
      {children}
    </ImageWithHeadAndOverlineWrapper>
  );
};

const ImageWithHeadAndOverlineWrapper = styled.div`
  position: relative;
  color: initial;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;

  ${OnHoverAppearingTextline} {
    opacity: 0;
  }

  &:hover {
    ${OnHoverAppearingTextline} {
      opacity: 1;
    }

    > img {
      transition: transform 0.3s ease;
      transform: scale(1.03);
    }
  }
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.33));
  }
`;
